/**
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import * as React from 'react';

interface IFileUploadProps {
  id: string;
  accept: string[];
  callback: Function;
  callbackkey: string;
  children?: React.ReactNode;
  ref: React.Ref<HTMLInputElement>;
}

const FileUpload = (props: IFileUploadProps) => {
  return (
    <>
      <input
        ref={props.ref}
        type="file"
        id={props.id}
        onChange={() => props.callback(props.callbackkey)}
        accept={props.accept.join(',')}
        hidden
      />
      <label className="btn btn-primary btn-inline" htmlFor={props.id}>
        {props.children}
      </label>
    </>
  );
};

export default FileUpload;
